import { ActionBarBehavior } from '../action-bar-behavior';
import { ActionBarType } from 'src/shared/constants/action-bar-type.enum';
import { ActionBarConfig } from 'src/shared/model/action-bar-config';
import { Subscription, Subject } from 'rxjs';
import { CommonConstants } from 'src/shared/constants/common-constants.enum';
import { CommonInits } from 'src/shared/constants/common-init';
import { ActionState } from 'src/shared/constants/action-state.enum';
import * as _ from 'lodash';
import { CustomActionBarTypeEnum } from 'src/shared/constants/custom-action-bar-type.enum';
import { ActionBarAction } from 'src/shared/constants/action-bar.action';
import { ConfirmationDialogComponent } from 'src/shared/compoment/confirmation-dialog/confirmation-dialog.component';
import { takeUntil } from 'rxjs/operators';
import { CustomActionEvent } from '../../service/custom-action-event';
import { NotificationService } from 'src/shared/service/notification.service';
import { ActionBarService } from 'src/shared/service/action-bar.service';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { HttpCustomService } from 'src/service/http-custom.service';
import { UrlType } from 'src/shared/constants/url-type.enum';
import { Injectable } from '@angular/core';
import {NavDataService} from "../../../../service/nav-data.service";

@Injectable()
export class DeleteActionBarBehavior extends ActionBarBehavior {
  config: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  ngUnsubscribe: Subject<boolean> = new Subject<boolean>();
  subscriptions: Subscription[] = [];

  constructor(
    private csEventService: ActionBarService,
    private dialogService: BsModalService,
    private httpService: HttpCustomService,
    private csCustomAction: CustomActionEvent,
    private notificationService: NotificationService,
    private navDataService: NavDataService
  ) {
    super();
  }

  executeAction(actionBarConfig: ActionBarConfig, selectedRecords: any[], additionalParams: any) {
    const actionConfig = _.find(actionBarConfig.buttonBarConfigs, conf => conf.actionBarType === ActionBarType.DELETE);
    if (actionConfig && actionConfig.customAction) {
      this.csEventService.emitChange(ActionBarAction.DELETE);
    } else {
      const deleteModel = _.keys(selectedRecords);
      this.config.initialState = CommonInits.confirmDialogForPerformAct(ActionState.DELETE, _.size(selectedRecords) > 1);
      const confirmState = this.dialogService.show(ConfirmationDialogComponent, this.config);
      confirmState.setClass('modal-dialog-centered');
      this.subscriptions.push(this.dialogService.onHide.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
        if (confirmState.content.confirmed) {
          this.httpService.post(actionBarConfig.urlType[UrlType.DELETE], deleteModel)
            .pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (res: any) => {
              const actionConfig = _.find(actionBarConfig.buttonBarConfigs, conf => conf.actionBarType === ActionBarType.DELETE);
              if (res) {
                // Listing view
                if (!actionBarConfig.isEdit) {
                  if (actionBarConfig.deleteMessageNoRef) {
                    this.notificationService.showPerformSuccessManyRecord(ActionState.DELETE_NO_REF, 0);
                  } else {
                    const noOfSuccess = res.length + '/' + _.keys(selectedRecords).length;

                    // Show customized toast message
                    if (actionConfig.confirmModel) {
                      const {notification} = actionConfig.confirmModel;
                      const bodyMessage = actionConfig.isWithoutReference ? notification.body : noOfSuccess + notification.body;
                      this.notificationService.open({
                        title: notification.title,
                        type: notification.type,
                        body: bodyMessage
                      });
                    } else {
                      this.notificationService.showPerformSuccessManyRecord(ActionState.DELETE, noOfSuccess);
                    }
                  }
                  // For case table list in detail screen, it's no need back to listing view
                  this.csCustomAction.emitChange({type: CustomActionBarTypeEnum.DELETE, value: false, actionId: additionalParams.actionId});
                } else {
                  if (actionBarConfig.deleteMessageNoRef) {
                    this.notificationService.showPerformSuccessOneRecord(ActionState.DELETE_NO_REF);
                  } else {
                    this.notificationService.showPerformSuccessOneRecord(ActionState.DELETE);
                  }
                  // For case overview in detail screen, it's need back to listing view
                  this.csCustomAction.emitChange({type: CustomActionBarTypeEnum.DELETE, value: true, actionId: additionalParams.actionId});
                }
              } else {
                // Listing view
                if (!actionBarConfig.isEdit) {
                  const noOfSuccess = res.length + '/' + _.keys(selectedRecords).length;
                  if (actionConfig.confirmModel) {
                    const {notification} = actionConfig.confirmModel;
                    const bodyMessage = actionConfig.isWithoutReference ? notification.body : noOfSuccess + notification.body;
                    this.notificationService.open({
                      title: notification.title,
                      type: notification.type,
                      body: bodyMessage
                    });
                  } else {
                    this.notificationService.showPerformSuccessManyRecord(ActionState.DELETE, noOfSuccess);
                  }
                }
              }
            });
          if (actionConfig && actionConfig.isRefreshNav) {
            setTimeout(() => {
              this.navDataService.emitRefreshChange(true);
            }, 300);
          }
        }
        this.unsubscribe();
      }));
    }
  }

  isActionBar(type: ActionBarType): boolean {
    return ActionBarType.DELETE === type;
  }

  unsubscribe() {
    _.forEach(this.subscriptions, (subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

}
